export default {
  tags: 'Etiquetas',
};
